
















































import Vue from 'vue'
import { getModule } from 'vuex-module-decorators'
import Component from 'vue-class-component'
import ErrorMessages from '@/components/ErrorMessages.vue'
import Icon from '@/components/Icon.vue'
import Password from '@/components/inputs/Password.vue'
import { validatePassword, validateEmail } from '@/utils/helpers'
import { UserModule } from '@/store/modules/user.module'
import Api from '@/api'
import Input from '@/components/inputs/Input.vue'
import Card from '@/components/Card.vue'

@Component({
  components: {
    Card,
    Input,
    Icon,
    Password,
    ErrorMessages
  }
})
export default class ResidentSignUp extends Vue {
  code: string = ''
  email: string = ''
  password: string = ''
  firstName: string = ''
  lastName: string = ''
  repeatPassword: string = ''
  isValidCode: boolean = true
  isCodeChecked: boolean = true
  isValidEmail: boolean = false
  isValidPassword: boolean = false
  isValidRepeatPass: boolean = false
  isInvalidToken: boolean = false
  isSubmitting: boolean = false
  hasError: boolean = false
  userModuleInstance: UserModule = getModule(UserModule, this.$store)
  year: number = new Date().getFullYear()
  backendValidationErrors: String[] = []
  validateEmail = validateEmail

  validateRepeatPass (isValid: boolean) { 
    this.isValidRepeatPass = isValid
  }

  validatePass (isValid: boolean) { 
    this.isValidPassword = isValid 
  }

  mounted (): void {
    const code = localStorage.getItem('zunta_oneTimeCode')
    if (code) {
      this.isCodeChecked = true
      this.code = code
    }
  }

  redirectUrl (): string {
    const user = Api.getUser()
    if (user && user.isResident()) {
      return '/app/portal/resident-general'
    }
    return '/login'
  }

  async next (): Promise<void> {
    this.validate()
    if (!this.hasError) {
      this.isSubmitting = true
      const form = {
        email: this.email,
        code: this.code,
        password: this.password,
        firstName: this.firstName,
        lastName: this.lastName
      }
      const result = await this.userModuleInstance.createResidentUser(form)
      if (result === 'OK') {
        await this.$router.push(this.redirectUrl())
      } else {
        this.backendValidationErrors = []
        this.backendValidationErrors.push(result.message)
      }
      this.isSubmitting = false
    }
  }

  validate () {
    this.isValidPassword = !!validatePassword(this.password) && 
    !!validatePassword(this.repeatPassword) &&
    this.password === this.repeatPassword
    this.isValidCode = !!(this.code && this.code.trim().length)
    this.isValidEmail = !!(this.email && validateEmail(this.email))
    this.hasError = ![
      this.isValidEmail,
      this.isValidCode,
      this.isValidPassword,
      this.firstName.length,
      this.lastName.length
    ].every(val => val)
  }
}
